import { generatePath } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';

import type { Site } from '@/api/fe-api/domain/entities/site';
import { Link } from '@/components/ui/link';
import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';

export type CardTasksProps = {
  site: Site;
  className?: string;
};

export function CardTasks({ site, className }: CardTasksProps) {
  const path = generatePath('/tasks?group=:groupId', {
    groupId: site.name.replaceAll(' ', '_'),
  });

  return (
    <StatsBox
      className={className}
      icon={{ element: <ClipboardList /> }}
      title="Open Tasks"
      value={site.nbOpenTasks}
    >
      <StatsBox.Action>
        <Link to={path}>View Tasks</Link>
      </StatsBox.Action>
    </StatsBox>
  );
}
